var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.event)?_c('div',{attrs:{"id":"event"}},[_c('cg-event-detail',{attrs:{"id":"event-detail","event":_vm.event.data}}),_c('cg-event-navigation',{attrs:{"id":"event-navigation","uid":_vm.uid}}),_c('cg-misc')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }